import 'twin.macro';
import React, { useCallback, useEffect, useState } from 'react';
import Textarea from 'components/Form/Textarea';
import _debounce from 'lodash-es/debounce';
import { GlobalRemarkAIWrapper } from 'containers/Livrets/LivretEval/LivretEleve/components/LivretEleve/GlobalRemark/GlobalRemarkAIWrapper';

interface Props {
  value: string;
  onChange?: (v: string) => void;
  readonly?: boolean;
  livretEleveId: string;
  withIA?: boolean;
}

export function GlobalRemark(props: Props) {
  const { onChange, readonly, livretEleveId, withIA } = props;
  const [value, setValue] = useState<string>(props.value);
  const [isEditing, setIsEditing] = useState(false);
  const [isAILoading, setIsAILoading] = useState(false);
  useEffect(() => {
    // this useeffect is required for sync feature
    if (!isEditing && props.value !== value) {
      // make sure to set state only if we are not in edit mode to prevent race conditions
      setValue(props.value);
    }
  }, [props.value]);
  const debouncedSave = useCallback(
    _debounce(nextValue => onChange && onChange(nextValue), 500),
    [],
  );

  const handleChange = nextValue => {
    setValue(nextValue);
    debouncedSave(nextValue);
  };
  if (readonly) {
    return <div tw="whitespace-pre-line">{value}</div>;
  }

  if (withIA) {
    return (
      <GlobalRemarkAIWrapper
        value={value}
        visible={isEditing}
        livretEleveId={livretEleveId}
        onLoadingStateChange={setIsAILoading}
        onCancel={() => {
          setIsEditing(false);
        }}
        onChange={v => {
          setIsEditing(false);
          handleChange(v);
        }}
      >
        <Textarea
          minRows={4}
          removeHandle={!onChange}
          onFocus={() => {
            setIsEditing(true);
          }}
          onBlur={() => {
            if (!isAILoading) {
              setTimeout(() => {
                setIsEditing(false);
              }, 100);
            }
          }}
          aria-label="Appreciation generale"
          value={value}
          onChange={e => handleChange(e.currentTarget.value)}
          withCount
          maxLength={1500}
          tw="pb-10"
        />
      </GlobalRemarkAIWrapper>
    );
  }
  return (
    <Textarea
      minRows={4}
      removeHandle={!onChange}
      onFocus={() => setIsEditing(true)}
      onBlur={() => setIsEditing(false)}
      aria-label="Appreciation generale"
      value={value}
      onChange={e => handleChange(e.currentTarget.value)}
      withCount
      maxLength={1500}
    />
  );
}
